var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7289 26.25H43.6445V30.625H8.7289V26.25ZM43.6445 17.5H8.7289V13.125H43.6445V17.5ZM30.5511 65.625L34.8815 70H0V0H52.3734V46.0742L50.1912 48.2275L48.0089 46.04V4.375H4.36445V65.625H30.5511ZM50.1912 69.8975L50.2935 70H50.0889L50.1912 69.8975ZM43.6445 39.375L39.2459 43.75H8.7289V39.375H43.6445ZM32.8357 52.5L37.2001 56.875H8.7289V52.5H32.8357ZM53.294 59.0625L61 66.8213L57.9312 69.8975L50.1912 62.1729L42.4511 69.9316L39.3823 66.8213L47.1224 59.0625L39.3823 51.3037L42.4511 48.2275L50.1912 55.9863L57.9312 48.2275L61 51.3379L53.294 59.0625Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCanceled);
export default __webpack_public_path__ + "static/media/file-canceled.e8a7e1fb67be299b2d4a9459aaee8267.svg";
export { ForwardRef as ReactComponent };